<template>
  <model-crud
    :model="model"
    :fields="fields"
    :include="['companies', 'users']"
  />
</template>

<script>
import ModelCrud from '@/components/ModelCrud'
import CompanyGroup from '@/models/CompanyGroup'
import Company from '@/models/Company'
import User from '@/models/User'

export default {
  data () {
    return {
      model: CompanyGroup,
      fields: {
        name: {
          label: this.$t('headers.name'),
          fill: true
        },
        description: {
          label: this.$t('headers.description'),
          fill: true
        },
        passwordComplexity: {
          label: this.$t('headers.passwordComplexity'),
          type: 'enum',
          values: Company.enums.passwordComplexity,
          list: false,
          fill: true,
          required: true,
          default: '3'
        },
        passwordExpiry: {
          label: this.$t('headers.passwordExpiry'),
          type: 'number',
          list: false,
          fill: true,
          hint: this.$t('inDays'),
          required: true
        },
        companies: {
          label: this.$t('headers.companies'),
          type: 'references',
          model: Company,
          fill: true,
          editable: false
        },
        users: {
          label: this.$t('headers.admins'),
          type: 'references',
          model: User,
          list: false,
          fill: true,
          display: 'username',
          filters: {
            role: '[EQ]GROUP_ADMIN'
          }
        },
        enabled: {
          label: this.$t('headers.enabled'),
          type: 'bool',
          default: true,
          fill: true
        }
      }
    }
  },
  components: {
    ModelCrud
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// CompanyGroups.vue?bc7c38ba